<div id="app-language-selector">
    <select id="language-selector" [formControl]="selectedLocale" (change)="onLanguageSelect()" data-testid="customerregistration.select.languageselector">
        @for(locale of locales; track locale.code){
        <option value="{{locale.code}}">{{locale.name}}</option>
        }
    </select>
</div>